import React from 'react'

const DoiteasyLogoSmall = () => {
  return (
    <h1 className="text-[30px] -tracking-[0.05em] font-[600] text-doiteasy-blue font-space-grotesk">doiteasy</h1>
  )
}

export default DoiteasyLogoSmall